// extracted by mini-css-extract-plugin
export var brand = "_bg-9";
export var compact = "_bg-6";
export var extraSmall = "_bg-7";
export var icon = "_bg-0";
export var large = "_bg-4";
export var light = "_bg-1";
export var medium = "_bg-5";
export var outline = "_bg-b";
export var primaryDark = "_bg-a";
export var primaryLight = "_bg-8";
export var primaryModern = "_bg-c";
export var success = "_bg-2";
export var successSolid = "_bg-3";